module.exports = __webpack_public_path__ + "img/meta-icon_Announs.c2c99e86.png";